import QueryString from "qs";

import AxiosInstance from "./axiosInstance.js";
import { initiateSSOLogin } from "../utils/initiateSSOLogin";

const getBaseURL = () => process.env.REACT_APP_URL + "/advisor/uf/api/v1/";

export function getRequest(url, params) {
  return AxiosInstance.get(url, params);
}

export function getRequestWithAuthorization(url, authorization, i18n) {
  const common = {
    Authorization: `Basic ${authorization}`,
    "Accept-Language": i18n.language || "en",
  };
  AxiosInstance.defaults.headers.common = common;
  return AxiosInstance.get(url);
}

export function updateLanguageInHeaders(language) {
  AxiosInstance.defaults.headers.common["Accept-Language"] = language || "en";
}

// Common error handler for API responses
function handleApiResponse(response) {
  console.log("API Response:", response?.status, response?.data);
  // if (!response || !response.data) {
  //   throw new Error("No response data received");
  // }
  if (response?.status && response.status === 401) {
    // Initiate SSO login again using utility
    initiateSSOLogin(window.location.origin + window.location.pathname);
    return; // No need to throw error, redirecting
  }
  // if (response?.status && response.status !== 200) {
  //   console.log("API Error:", response?.error, response?.detail?.error);
  //   const errorMsg = response?.data?.detail?.error || response?.data?.error;
  //   throw new Error(errorMsg);
  // }
  return response.data || response;
}

export function postRequest(url, payload) {
  return AxiosInstance.post(url, payload).then(handleApiResponse);
}

export function putRequest(url, payload) {
  return AxiosInstance.put(url, payload).then(handleApiResponse);
}

export function deleteRequest(url, data = {}) {
  return AxiosInstance.delete(url, { data }).then(handleApiResponse);
}

export function patchRequest(url, payload, isAdminAPI = false) {
  url = isAdminAPI ? url : `${getBaseURL()}${url}`;
  return AxiosInstance.patch(url, payload).then(handleApiResponse);
}

export const paramsSerializer = (params) =>
  QueryString.stringify(params, { arrayFormat: "repeat" });
